module.exports = __webpack_public_path__ + "img/icon_profile_active_pc.6f58e53d.svg";